export default {
    FOLDER: 'folder',
}
